import { AuthType } from "../type";

const initialState = {
  user: JSON.parse(localStorage.getItem("user")),
  authError: undefined,
  isLoading: false,
  message: undefined,
  customerCodeList: undefined,
  cscList: undefined,
  selectedCscId: `${localStorage.getItem("loggedCscId")}-${localStorage.getItem(
    "loggedSubareaId"
  )}-${localStorage.getItem("loggedCscName")}`,
};

const authReducer = (state = initialState, action) => {
  const { type, payload = {} } = action;
  const { user, message } = payload;
  switch (type) {
    case AuthType.LOGIN:
      return {
        ...state,
        user,
        authError: undefined,
        isLoading: false,
        message,
      };
    case AuthType.AUTH_ERROR:
      return {
        ...state,
        user: undefined,
        authError: payload,
        isLoading: false,
      };
    case AuthType.LOADING:
      return { ...state, isLoading: payload };
    case AuthType.LOGOUT:
      return {
        ...state,
        user: undefined,
        isLoading: false,
        authError: undefined,
      };
    case AuthType.GET_CUSTOMER_CODE_LIST:
      return {
        ...state,
        isLoading: false,
        authError: undefined,
        customerCodeList: payload,
      };
    case AuthType.GET_CSC_LIST:
      return {
        ...state,
        isLoading: false,
        authError: undefined,
        cscList: payload,
      };
    case AuthType.SELECTED_CSC_ID:
      return { ...state, selectedCscId: payload };
    
    default:
      return state;
  }
};
export default authReducer;
